/* ============
 * Mutation types for the account module
 * ============
 *
 * The mutation types that are available
 * on the account module.
 */

export const GET_ACCOUNT = 'GET_ACCOUNT';

export default {
  GET_ACCOUNT,
};



// WEBPACK FOOTER //
// ./src/store/modules/account/mutation-types.js